import { App as KonstaApp } from 'konsta/react'
import { RouterProvider } from 'react-router'
import { CapacitorProvider, SessionProvider } from '@/providers'
import { router } from './router'

export function App() {
  return (
    <KonstaApp theme="ios" safeAreas>
      <CapacitorProvider>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </CapacitorProvider>
    </KonstaApp>
  )
}
